
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { RequestDetails } from "@/types/notifications";

@Component({
  components: {}
})
export default class EmailForHost extends Vue {
  @Prop()
  requestDetails!: RequestDetails;

  get emailForHostText() {
    return getSupportTicketEmailText(
      this.requestDetails.responseCode,
      this.requestDetails.requestTimeGmt,
      this.requestDetails.requestUrl,
      this.requestDetails.requestMethod
    );
  }

  copyEmailForHostTextToClipboard() {
    const textArea = this.$refs.emailForHostTextarea;
    // @ts-ignore
    textArea.focus();
    // @ts-ignore
    textArea.select();
    document.execCommand("copy");
  }
}

function getSupportTicketEmailText(
  errorCode: string,
  requestTimeGmt: string,
  requestUri: string,
  requestType: string
) {
  return `Hi Hosting Provider Support,

When using the Breakdance or Oxygen plugin, my server failed to fulfill the following request as expected. Instead, it returned an error code.

Error Code: ${errorCode}
Request Time: ${requestTimeGmt}
Request URI: ${requestUri}
Request Type: ${requestType}

Why did the server return a ${errorCode} error?

If this isn't something you can fix, please send me the full text of the error from the relevant error log file.

Best Regards,
Your Name`;
}
